module.exports = __webpack_public_path__ + "assets/img/google.686f8efa.svg";